/* eslint-disable react/no-unstable-nested-components */

import React, { useRef } from 'react';
import 'github-markdown-css/github-markdown.css';
import markdownIt from 'markdown-it';
import markdownItCodeCopy from 'markdown-it-copy-code';
import svg from './latex';
import hightLight from 'markdown-it-highlightjs';
import 'highlight.js/styles/atom-one-light.min.css';
import 'markdown-it-copy-code/styles/base.css';
import 'markdown-it-copy-code/styles/medium.css';
import { useCopyCode } from 'markdown-it-copy-code';

const md = markdownIt();

useCopyCode('markdown-copy-code-button');

md.use(svg, { server: 'https://www.zhihu.com/equation' })
  .use(hightLight, { inline: true })
  .use(markdownItCodeCopy);

export function Markdown(
  props: {
    content: string;
    fontSize?: number;
  } & React.DOMAttributes<HTMLDivElement>,
) {
  // console.log(props.content)
  const mdRef = useRef<HTMLDivElement>(null);

  // console.log(props.content)
  return (
    <div
      className="markdown-body"
      style={{
        fontSize: `${props.fontSize ?? 14}px`,
      }}
      ref={mdRef}
      onContextMenu={props.onContextMenu}
      onDoubleClickCapture={props.onDoubleClickCapture}
      dir="auto"
    >
      <div dangerouslySetInnerHTML={{ __html: md.render(props.content) }}></div>
    </div>
  );
}
